import React, { useCallback, useState } from 'react';
import { scriptExtBaseEndpoint, scriptInjectedFn } from '../../config';
import { ReactEmbeddedControlWithMemo } from './react-embedded-control';
const linkHrefs = [
  //   `${scriptExtBaseEndpoint}/static/css/chunk.grant.component.export.css`,
  //   `${scriptExtBaseEndpoint}/static/css/main.grant.component.export.css`,
];

const scriptSrcs = [
  `${scriptExtBaseEndpoint}/bootstrap.js`,
  `${scriptExtBaseEndpoint}/static/js/chunk.grant.component.export.js`,
  `${scriptExtBaseEndpoint}/static/js/main.grant.component.export.js`,
];

const id = 'ext-loader';

export const ScriptLoader = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const afterLoad = useCallback(() => {
    scriptInjectedFn._grant_hydrate = window['_grant_hydrate'];
    scriptInjectedFn.getDataFileEndpoint = window['getDataFileEndpoint'];

    setLoaded(true);
  }, []);

  return (
    <React.Fragment>
      <ReactEmbeddedControlWithMemo
        linkHrefs={linkHrefs}
        scriptSrcs={scriptSrcs}
        afterLoad={afterLoad}
        id={`${id}-script`}
      />

      {loaded === true && <React.Fragment>{children}</React.Fragment>}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/script-loader/script-loader.js